export default {
  selectedLocationGroup: state => state.selectedLocationGroup,
  createLocationGroupDialog: state => state.createLocationGroupDialog,
  locationGroupEditDialog: state => state.locationGroupEditDialog
}
